if (typeof global === "undefined") {
  window.global = window
}

import { ChakraProvider } from "@chakra-ui/react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { OpenAPI } from "./client"
import { routeTree } from "./routeTree.gen"
import theme from "./theme"

const configuredApiBase = String(import.meta.env.VITE_API_DOMAIN ?? "").trim()
OpenAPI.BASE =
  configuredApiBase && configuredApiBase.toLowerCase() !== "undefined"
    ? configuredApiBase
    : "/api"
OpenAPI.TOKEN = async () => {
  return localStorage.getItem("access_token") || ""
}

const queryClient = new QueryClient()

const router = createRouter({ routeTree })
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

// Get the root container from the document
const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Failed to find the root element")

// Create a React root instance and render your application
ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ChakraProvider>
  </StrictMode>,
)
